import { useEffect, useState } from 'react';
import { AdminLayout } from '@/admin/components/AdminLayout';
import ScrapperEventsStats from '@/admin/components/scrapper-events/ScrapperEventsStats';
import ScrapperEventsTable from '@/admin/components/scrapper-events/ScrapperEventsTable';
import type { ScrapperEventStatus } from '@/admin/components/scrapper-events/types';

const REFRESH_INTERVAL_MS = 30000;

export default function ScrapperEventsPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [filterStatus, setFilterStatus] = useState<ScrapperEventStatus | 'all'>('all');
  const [lastRefresh, setLastRefresh] = useState<Date>(new Date());

  const triggerRefresh = () => {
    setRefreshKey((k) => k + 1);
    setLastRefresh(new Date());
  };

  useEffect(() => {
    if (!autoRefresh) return;
    const id = setInterval(triggerRefresh, REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
  }, [autoRefresh]);

  return (
    <AdminLayout
      title="Monitoreo de scrappers"
      subtitle="Webhooks recibidos desde los scrappers (tabla scrapper_events). Detecta fallos, reintenta y revisa el detalle del error."
      actions={
        <div className="flex items-center gap-3">
          <span className="font-mono text-[10px] uppercase tracking-wider text-slate-500">
            últ. refresh{' '}
            <span className="text-slate-700 dark:text-slate-300">
              {lastRefresh.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'America/Santiago' })}
            </span>
          </span>
          <button
            onClick={() => setAutoRefresh((v) => !v)}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider transition-all ${
              autoRefresh
                ? 'bg-emerald-100 text-emerald-700 ring-1 ring-inset ring-emerald-300/50 dark:bg-emerald-950/40 dark:text-emerald-400 dark:ring-emerald-900/50'
                : 'border border-slate-200 bg-white text-slate-500 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-400'
            }`}
          >
            <span className="relative flex h-1.5 w-1.5">
              {autoRefresh && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />}
              <span className={`relative inline-flex h-1.5 w-1.5 rounded-full ${autoRefresh ? 'bg-emerald-500' : 'bg-slate-400'}`} />
            </span>
            {autoRefresh ? 'Live · 30s' : 'Pausado'}
          </button>
        </div>
      }
    >
      <div className="space-y-6">
        <ScrapperEventsStats refreshKey={refreshKey} onFilterFailed={() => setFilterStatus('failed')} />

        <ScrapperEventsTable refreshKey={refreshKey} onRefresh={triggerRefresh} initialStatus={filterStatus} />
      </div>
    </AdminLayout>
  );
}
